$(document).on('submit','form[data-remote!=true]',function(){
  let loading = document.getElementById('loading');

  if(loading) {
    loading.classList.remove('d-none');
  }
});
